var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"popup-icon",class:this.name},[_c('font-awesome-icon',{attrs:{"icon":this.icon}})],1),_c('td',{staticClass:"popup-text"},[_vm._v(_vm._s(this.value)+" "+_vm._s(this.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }